import { render } from "./Events.vue?vue&type=template&id=b93331c0&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"

import "./Events.vue?vue&type=style&index=0&id=b93331c0&scoped=true&lang=css"

import exportComponent from "/Users/ward/Projects/Chelsea/sherryV2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b93331c0"]])

export default __exports__